import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box } from "../Box/Box.mjs";
import { ActionsContext } from "./ActionsContext.mjs";
import { root, actionsBreakpoint } from "./Actions.css.mjs";
const actionsSpace = "xsmall";
const Actions = ({ size, data, children }) => {
  const contextValue = useMemo(() => ({ size }), [size]);
  return /* @__PURE__ */ jsx(ActionsContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx(
    Box,
    {
      display: "flex",
      flexDirection: { mobile: "column", [actionsBreakpoint]: "row" },
      flexWrap: "wrap",
      gap: actionsSpace,
      className: root,
      data,
      children
    }
  ) });
};
export {
  Actions
};
